import { render, staticRenderFns } from "./OrderMessagePost.vue?vue&type=template&id=60e1d705&scoped=true"
import script from "./OrderMessagePost.vue?vue&type=script&lang=js"
export * from "./OrderMessagePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e1d705",
  null
  
)

export default component.exports